module.exports = __webpack_public_path__ + "static/img/67.8558cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/67.png
// module id = vkHd
// module chunks = 0